import { useMatch } from '@tanstack/react-location';
import { useTranslation } from '@frontend/i18n';
import { SettingsPage, SettingsPageLayout } from '@frontend/settings-ui';
import { NewAppointmentTypeButton } from '../../components/AppointmentTypesV3/NewAppointmentTypeButton';
import { useSchedulingLocationInfo } from '../../hooks/use-scheduling-location-info';
import { MultiLocationAppointmentTypes } from '../AppointmentTypes/MultiLocationAppointmentTypes';
import { AppointmentTypeV3Page } from './AppointmentTypesV3Page';

export const AppointmentTypeV3Settings = () => {
  const { t } = useTranslation('schedule-settings');
  const { params } = useMatch();
  const { getScopeName, selectedLocationIds } = useSchedulingLocationInfo();
  const locationId = (selectedLocationIds.length === 1 ? selectedLocationIds[0] : params?.locationId) ?? '';

  return (
    <SettingsPageLayout>
      <SettingsPage
        settingsLocationConfig={{
          chipLabel: getScopeName(locationId),
          isSingleLocation: !!locationId,
        }}
        title={t('Appointment Types')}
        subtitle={t(
          "Customize appointment types for your practice. Edit settings for online booking and internal use. Changes affect Weave systems but won't sync to your practice management software."
        )}
        action={<NewAppointmentTypeButton locationId={locationId} />}
        maxWidth='100%'
      >
        {locationId ? (
          <AppointmentTypeV3Page locationId={locationId} />
        ) : (
          <MultiLocationAppointmentTypes shouldRenderV3Settings />
        )}
      </SettingsPage>
    </SettingsPageLayout>
  );
};
